module.exports = __webpack_public_path__ + "img/dsci0008.7d5c72b4.jpg";